'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjs_js_Any$() {
}
export { $c_sjs_js_Any$ as $c_sjs_js_Any$ };
$p = $c_sjs_js_Any$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
}
export { $h_sjs_js_Any$ as $h_sjs_js_Any$ };
$h_sjs_js_Any$.prototype = $p;
$p.Ui = (function(f) {
  return ((arg1$2) => f.j(arg1$2));
});
var $d_sjs_js_Any$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjs_js_Any$, "scala.scalajs.js.Any$", ({
  vP: 1,
  vR: 1,
  vS: 1
}));
export { $d_sjs_js_Any$ as $d_sjs_js_Any$ };
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$();
  }
  return $n_sjs_js_Any$;
}
export { $m_sjs_js_Any$ as $m_sjs_js_Any$ };
